module.exports = __webpack_public_path__ + "static/media/37.f1f94ca1.svg";